import { useCallback, useEffect, useRef } from 'react';
import 'intersection-observer';
export function useIntersectionObserver(_ref) {
  var _ref$rootMargin = _ref.rootMargin,
      rootMargin = _ref$rootMargin === void 0 ? '0px 0px 0px 0px' : _ref$rootMargin,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 1.0 : _ref$threshold,
      cb = _ref.cb;
  var observer = useRef();
  var nodeRef = useRef();
  var setRef = useCallback(function (node) {
    if (node) {
      nodeRef.current = node;
      observer.current = new IntersectionObserver(cb, {
        root: node,
        rootMargin: rootMargin,
        threshold: threshold
      });
    }
  }, [cb, rootMargin, threshold]);
  useEffect(function () {
    return function () {
      if (observer.current && nodeRef.current) {
        observer.current.unobserve(nodeRef.current);
      }
    };
  }, []);
  return {
    observer: observer,
    setRef: setRef
  };
}